import core, { App } from '@gin-betting/core';
import { Action, Middleware, MiddlewareAPI } from 'redux';

import {
    DEBUG_INFO_LOCALSTORAGE_KEY,
    TIME_UNIT_IN_MILLISECONDS,
} from 'app-constants';
import { State } from 'types';
import { markReachableEntities } from './actions';
import { MARK_REACHABLE_ENTITIES } from './constants';
import { locateSweepableMatches } from './utils';

const {
    entities: {
        actions: { deleteEntities },
    },
} = core;

const GC_SCHEDULE_TIMEOUT = 0.5 * TIME_UNIT_IN_MILLISECONDS.minute;

function makeMiddleware(): Middleware {
    let timerId: number;

    return ({ dispatch, getState }: MiddlewareAPI<State>) => {
        const mark = () => {
            window.clearTimeout(timerId);
            dispatch(markReachableEntities(App.EntityNames.Matches));
        };

        if (localStorage.getItem(DEBUG_INFO_LOCALSTORAGE_KEY)) {
            (window as any).__app.dispatchGC = mark;
        }

        const sweep = (arg: FirstArgument<typeof deleteEntities>) => {
            dispatch(deleteEntities(arg));
        };

        const scheduleDeallocation = () => {
            timerId = window.setTimeout(mark, GC_SCHEDULE_TIMEOUT);
        };

        scheduleDeallocation();

        return next => (action: Action) => {
            switch (action.type) {
                case MARK_REACHABLE_ENTITIES: {
                    const state = getState();
                    const sweepableMatchEntities = locateSweepableMatches(
                        state
                    );

                    if (sweepableMatchEntities) {
                        sweep(sweepableMatchEntities);
                    }

                    scheduleDeallocation();

                    return;
                }

                default:
                    return next(action);
            }
        };
    };
}

export default makeMiddleware;
